module.exports = __webpack_public_path__ + "img/address1.25132b6d.jpg";